import React, { useEffect, useState } from "react";
import general, { redux } from "../../../../../general";
import "./css/RedEnvelpoe.css";

export default function OpenRedEnvelope(props) {
  const [attach, setAttach] = useState(props?.attach);
  const [init, setInit] = useState(false);

  useEffect(() => {
    redux.subscribe(() => {
      const state = redux.getState();
      if (state.refreshRedEnvelopeData) {
        if (
          parseInt(attach?.redenvelope_id) ==
          parseInt(state.refreshRedEnvelopeData.redenvelope_id)
        ) {
          setAttach(state.refreshRedEnvelopeData);
        }
      }
    });
  }, []);

  const handleOpen = () => {
    if (props.handleOpen) {
      props.handleOpen(attach);
    }
  };

  // 获取红包详情
  const getRedEnvelopeInfo = (redenvelope_id) => {
    general.axios
      .post("/getRedEnvelopeInfo", {
        redenvelope_id,
      })
      .then((res) => {
        const { status, data } = res.data;
        if (status.succeed) {
          setAttach((prev) => ({ ...prev, ...data }));
          setInit(true);
        }
      });
  };

  useEffect(() => {
    if (!init) {
      getRedEnvelopeInfo(attach?.redenvelope_id);
    }
  }, [init]);

  const handleAction = () => {
    general.axios.post("/taskAccomplish", {
      redenvelope_id: attach.redenvelope_id,
    });
    if (props.handleAction) {
      props.handleAction(attach);
    }
  };

  const formatSubscribeTime = (timestamp) => {
    if (!timestamp) return null;
    const now = new Date();
    const subscribeDate = new Date(timestamp * 1000);

    const isToday = now.toDateString() === subscribeDate.toDateString();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    const isTomorrow = tomorrow.toDateString() === subscribeDate.toDateString();

    let dayString = "";
    if (isToday) {
      dayString = "今日";
    } else if (isTomorrow) {
      dayString = "明日";
    } else {
      dayString = `${
        subscribeDate.getMonth() + 1
      }月${subscribeDate.getDate()}日`;
    }

    const hours = String(subscribeDate.getHours()).padStart(2, "0");
    const minutes = String(subscribeDate.getMinutes()).padStart(2, "0");

    return (
      <>
        {dayString}{" "}
        <span
          style={{
            textAlign: "center",
            backgroundColor: "white",
            borderRadius: 2,
            padding: "0 2px",
            color: "#EB3F40",
          }}
        >
          {hours}
        </span>
        <span style={{ padding: "0 3px" }}>时</span>
        <span
          style={{
            textAlign: "center",
            backgroundColor: "white",
            borderRadius: 2,
            padding: "0 2px",
            color: "#EB3F40",
          }}
        >
          {minutes}
        </span>
        <span style={{ paddingLeft: 3, paddingRight: 3 }}>分</span>
      </>
    );
  };

  return (
    <div>
      <div
        className={
          "open-red-envelope-container " +
          (parseInt(attach.scene_type) == 2 ? "task-bg" : "")
        }
      >
        <div className="open-red-envelope-bg-img">
          <img src="resources/251222/re_open_bg.png" alt="" />
        </div>
        <div
          className={
            "open-red-envelope-content " +
            (parseInt(attach.scene_type) == 2 ? "task-content" : "")
          }
        >
          <div>
            <div className="red-envelope-title">
              <img
                className="red-envelope-avatar"
                src={attach.send_user.avator}
                alt=""
              />
              <div className="red-envelope-name">{attach.send_user.title}</div>
            </div>
            <div className="red-envelope-type">
              <img
                src={
                  "resources/251222/" +
                  (parseInt(attach.reward_type) == 1
                    ? "re_gold.png"
                    : "re_voucher.png")
                }
                alt=""
                height={25}
              />
              <div className="red-envelope-type-value">
                {parseInt(attach.reward_type) == 1 ? "金币红包" : "代金券红包"}
              </div>
            </div>
            {(attach.is_preview_red === true ||
              parseInt(attach.is_preview_red) == 1) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 13,
                  color: "#F7D380",
                  paddingTop: 20,
                  fontWeight: 500,
                }}
              >
                <div>{formatSubscribeTime(attach.subscribe_time)}</div>
                <div style={{ paddingLeft: 5 }}>开抢</div>
              </div>
            )}
            {parseInt(attach.scene_type) == 2 && (
              <div className="red-envelope-task">
                <div>
                  {parseInt(attach.task_type) == 1 ? "下载" : "发帖"}每满
                </div>
                <div className="task_condition">
                  {attach.task_condition.completed_condition}/
                  {attach.task_condition.totle_condition}
                </div>
                <div>人 开抢</div>
              </div>
            )}
          </div>
          <div>
            <div className="open-btn" onClick={handleOpen}></div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50px",
              }}
            >
              <div className="tip-txt">{attach.task_desc}</div>
            </div>
          </div>
        </div>
        {parseInt(attach.scene_type) == 2 && (
          <div className="open-red-envelope-rain">
            <img
              className="logo"
              src={attach.task_condition.game_image}
              alt=""
            />
            <div className="title">{attach.task_condition.game_name}</div>
            <div className="btn" onClick={handleAction}>
              {parseInt(attach.task_type) == 1 ? "下载" : "发帖"}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
